module.exports = __webpack_public_path__ + "static/media/Finding-profitable-offers-online-552598.8f93a210.jpg";